export const getLastProjectKey = userId => `users:${userId}:last_project_id`
